var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5221 13.1882C21.5221 13.4838 21.7834 13.7229 22.1064 13.7229C22.4295 13.7229 22.6908 13.4815 22.6908 13.1882V11.936C22.7007 11.1012 21.9659 10.4153 21.0289 10.4062H16.9261H16.9187C16.4798 10.4062 16.0655 10.5619 15.7524 10.8462C15.4368 11.1305 15.2642 11.5096 15.2617 11.9112V13.1904C15.2617 13.486 15.5231 13.7252 15.8461 13.7252C16.1691 13.7252 16.4305 13.486 16.4305 13.1904V11.9315C16.428 11.8119 16.4748 11.6991 16.5661 11.6133C16.6573 11.5276 16.7781 11.478 16.9261 11.4757H21.0314C21.167 11.478 21.2854 11.5186 21.3766 11.6021C21.4678 11.6855 21.5221 11.7961 21.5221 11.9337V13.1882Z",
    fill: "#E60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5889 13.0288C9.72862 13.0288 9.03125 13.6697 9.03125 14.4603V16.3873L17.0239 20.0121C17.3716 19.2694 18.1257 18.7549 19 18.7549C19.8562 18.7549 20.5971 19.2483 20.9539 19.9662L28.9688 16.3873V14.4603C28.9688 13.6697 28.2714 13.0288 27.4111 13.0288H10.5889ZM9.03125 25.3399V17.8826L16.8193 21.4146V21.4414C16.8193 22.6457 17.7957 23.622 19 23.622C20.2043 23.622 21.1807 22.6457 21.1807 21.4414V21.3603L28.9688 17.8826V25.3399C28.9688 26.1305 28.2714 26.7714 27.4111 26.7714H10.5889C9.72862 26.7714 9.03125 26.1305 9.03125 25.3399ZM19 19.9C18.4839 19.9 18.0654 20.3185 18.0654 20.8346V21.5422C18.0654 22.0584 18.4839 22.4768 19 22.4768C19.5161 22.4768 19.9346 22.0584 19.9346 21.5422V20.8346C19.9346 20.3185 19.5161 19.9 19 19.9Z",
    fill: "#E60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.1b7c725b2ccd9705df62b83cd4b82936.svg";
export { ForwardRef as ReactComponent };